export { default } from "./SecondMainHeading";
